/**
 * TanStack Query mutation hook for uploading logo files.
 *
 * Wraps the POST /v1/uploads API call.
 * Returns { id, url } on success.
 */

import { useMutation } from "@tanstack/react-query";
import { uploadsApi } from "../../lib/api";
export { uploadKeys } from "./query-keys";

type UploadLogoInput = {
	file: File;
	token: string;
	walletAddress?: string;
};

export function useUploadLogo() {
	return useMutation({
		mutationFn: ({ file, token, walletAddress }: UploadLogoInput) =>
			uploadsApi.uploadLogo(file, token, walletAddress),
		// Caller can use onSuccess to get the upload id/url
	});
}
